@if (workPackage) {
  <wp-single-view [workPackage]="workPackage"
   />
}
